{
    const transformSizeInput = async (mainDiv: HTMLDivElement) => {
        const ul = mainDiv.querySelector('ul')
        if(ul === null)
            throw Error('artemis-input-transform [transformSizeInput]: ul element not found')

        // wait until dynamic content is fully loaded
        await (async () => {
            return new Promise(async (res, rej) => {
                const testElement: HTMLSpanElement | null = ul.querySelector('li span.tc-label-wrap')
                if(testElement === null)
                    rej("Test element not found")
                let i = 0
                for(; i<100; i++) {
                    // do test (check if there is any text content in test element)
                    if(testElement !== null && testElement.innerText.length > 0) {
                        res(`Found text content in test element after ${i * 20}ms`)
                        break
                    }
                    await (async () => {return new Promise(res => setTimeout(res, 20))})();
                }
                rej(`Text content in test element not found after ${i * 20}ms`)
            })
        })().catch(msg => {
            console.error(`artemis-input-transform [transformSizeInput]: ${msg}`)
        }).then(msg => {
            // console.log(`artemis-input-transform [transformSizeInput]: ${msg}`)

            // add headers
            // const headersDiv = document.createElement('div')
            // headersDiv.classList.add('artemis-sizeinput-headers')
            // headersDiv.innerHTML = '<span class="width-header">Bredde</span>'
            //                         + '<span class="multip-sign">&#215;</span>'
            //                         + '<span class="height-header">Højde</span>'
            //                         + '<span class="price-header">Pris</span>'
            // ul.parentElement?.insertBefore(headersDiv, ul)

            // transform li options
            ul.querySelectorAll('li').forEach(li => {
                const sizeSpan: HTMLSpanElement | null = li.querySelector('span.tc-label-text')
                if(sizeSpan === null)
                    throw Error('span.tc-label-wrap not found in li element')
                // const sizeMatch = sizeSpan.innerText.match(
                //     /(?<width>\d+([.,]\d+)?)\s*x\s*(?<height>\d+([.,]\d+)?)\s*(?<unit>\w+)?/
                // )
                // if(sizeMatch === null)
                //     throw Error("artemis-input-transform [transformSizeInput]: Can't match values in li span element.")
                // let widthStr = sizeMatch?.groups?.width !== undefined ? String(sizeMatch.groups.width) : 'err'
                // let heightStr = sizeMatch?.groups?.height !== undefined ? String(sizeMatch.groups.height) : 'err'
                // if(sizeMatch?.groups?.unit !== undefined) {
                //     widthStr += ` ` + sizeMatch.groups.unit
                //     heightStr += ` ` + sizeMatch.groups.unit
                // }
                // sizeSpan.innerHTML = `<span class="width-value">${widthStr}</span>`
                //                     + `<span class="multip-sign">&#215;</span>`
                //                     + `<span class="height-value">${heightStr}</span>`

                sizeSpan.innerHTML = `<span class="unformatted-value">${sizeSpan.innerText}</span>`

                // make li element clickable
                li.addEventListener('click', function(e) {
                    this.querySelector('input')?.click()
                })
            })
        })
    }

    const transformFrameStyleInput = async (mainDiv: HTMLDivElement) => {
        await (async () => {
            return new Promise(async (res, rej) => {
                let i = 0
                for(; i<100; i++) {
                    const posterImg: HTMLImageElement | null = document.querySelector('div.flickity-viewport div.slide.first img:nth-last-of-type(1)')
                    // do test (check if there is any text content in test element)
                    if(posterImg && posterImg.src.length > 0) {
                        console.log(`Found poster image after ${i * 20}ms`)
                        res(posterImg)
                        break
                    }
                    await (async () => {return new Promise(res => setTimeout(res, 20))})();
                }
                rej(`Poster image not found after ${i * 20}ms`)
            })
        })().catch(msg => {
            console.error(`artemis-input-transform [transformFrameStyleInput]: ${msg}`)
        }).then(posterImg => {
            const posterImgClone = document.createElement('img')
            posterImgClone.src = (posterImg as HTMLImageElement).src
            posterImgClone.classList.add('artemis-frame-preview-img')
            mainDiv.querySelectorAll('ul > li').forEach(li => {
                const optionImg: HTMLImageElement | null = li.querySelector('span.tc-label-wrap > img.radio-image')
                if(optionImg && optionImg.parentElement) {
                    optionImg.parentElement.insertBefore(posterImgClone.cloneNode(false), optionImg)
                } else {
                    const tcLabel = li.querySelector('span.tc-label-wrap > span.tc-label.radio-image-label')
                    if(tcLabel && tcLabel.parentElement)
                    {
                        tcLabel.parentElement.insertBefore(posterImgClone.cloneNode(false), tcLabel)
                    }
                }
            })
        })
    }

    const main = function (e: Event) {
        // artemis-style-sizeinput
        const artemisSizeInput: NodeListOf<HTMLDivElement> = document.querySelectorAll(
            'div.artemis-form-element.artemis-style-sizeinput'
        )
        artemisSizeInput.forEach(sizeInputDiv => transformSizeInput(sizeInputDiv))

        // artemis-style-framestyle (disabled, idea of putting image behind frame has been postponed)
        // const artemisFrameStyleDiv: HTMLDivElement | null = document.querySelector(
        //     'div.artemis-form-element.artemis-style-framestyle'
        // )
        // if(artemisFrameStyleDiv) {
        //     transformFrameStyleInput(artemisFrameStyleDiv)
        // }
    }

    window.addEventListener('DOMContentLoaded', main)
}